(function Module() {
	'use strict';

	mySynch.controller('FertilityCodesBasicController', [
		'$scope',
		'$timeout',
		'MySynchFactory',
		'ApiFactory',
		'ViewAuthorizationFactory',
		'mySynchEnumerationService',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		function FertilityCodesBasicController($s, $timeout, MSF, api, viewAuth,mySynchEnumSvc, perfMetricSvc, perfContextSvc, log) {
			
			$s.performanceContext = null;
			
			//#region Permissions
			$s.canUpdate = false;

		    // deregistration functions
			var deregOnPermissionChanged = null;
			var deregOnHerdFertilityProgramChanged = null;

			deregOnPermissionChanged = $s.$on('permission:changed', function onPermissionChanged() {
				checkPermissions();
			});

			function checkPermissions() {
				$s.canUpdate = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission','COMMON_SETTINGS_UPDATE'));
			}
			//#endregion Permissions

			function updateInputs() {
				var activeProgram = MSF.getActiveHerdFertilityProgram();
				var isCurrentEndDate = moment(activeProgram.programEndDate).subtract(moment(activeProgram.programEndDate).utcOffset(), 'minutes').isSame(moment('9999-12-31'));

				// activeProgram.programStartDate = new Date(activeProgram.programStartDate);
				activeProgram.programEndDate =  isCurrentEndDate || _.isNull(activeProgram.programEndDate) ? null : new Date(activeProgram.programEndDate);

				if (!_.isEmpty(activeProgram)) {
					activeProgram.displayedProgramEndDate = activeProgram.programEndDate ?
						new Date(moment(activeProgram.programEndDate).subtract(moment(activeProgram.programEndDate).utcOffset(), 'minutes').format()) : null;

					$s.programInputs[activeProgram.herdFertilityProgramId] = _.extend({}, defaultInputs, _.pick(activeProgram, _.keys(defaultInputs)));

					var program = $s.programInputs[activeProgram.herdFertilityProgramId];

					if (program.l1CleanUpShot || program.l2CleanUpShot) {
						program.noCleanUpShot = false;
					}
				}
			}

			function addOptions() {
				var none = {
					abbr: 'no',
					name: 'N/A',
					parityTypeId: 0
				};

				var parityTypes = _.filter(MSF.lists.parityType, function filterOutHeifer(parity) {
					return parity.abbr !== 'heifer';
				});

				parityTypes.unshift(none);

				_.extend($s.options, {
					parityTypes: parityTypes
				});
			}

			// these are defaults for inputs
			var defaultInputs = {
				timeAfterAIPregCheck: 35,
				timeUnitTypeId: _.get(_.find(MSF.lists.unitType,{code:"DAY"}),'unitTypeId'),//mySynchEnumeration.unitType().DAY.value,
				fertilityProgramFrequencyTypeId: 1,
				fertilityProgramPregnancyCheckFrequencyTypeId: 2,
				heatDetectionFollowUpAfterTAI: true,
				lactation1VoluntaryWithholdPeriod: 60,
				lactation2VoluntaryWithholdPeriod: 74,
				preferredPregCheckDayId: 2,
				programStartWeekdayId: 2,
				reSynchBeforeOrAfter: 'A',
				recheckDaysAfterAI: 60,
				useCorpusLuteum2ndProtocols: false,
				l1CleanUpShot: false,
				l2CleanUpShot: false,
				noCleanUpShot: true,
				herdFertilityProgramId: 1,
				displayedProgramStartDate: new Date(moment().subtract(12, 'months').format()),
				displayedProgramEndDate: null,
				tAIBreedToHeat: false,
				modifiedOn: null
			};

			$s.programInputs = {};

			$s.options = {
				programFrequency: [],
				pregnancyCheckFrequency: [],
				useCorpusLuteum2ndProtocols: [{
					value:		true,
					display:	'Yes'
				}, {
					value:		false,
					display:	'No'
				}],
				reSynchBeforeOrAfter: [{
					value:		'N',
					display:	'N/A'
				}, {
					value:		'B',
					display:	'Before'
				}, {
					value:		'A',
					display:	'After'
				}],
				heatDetectionFollowUpAfterTAI: [{
					value:		true,
					display:	'Yes'
				}, {
					value:		false,
					display:	'No'
				}],
				cleanUpShot: [{
					display:	'Heifer',
					model:		'heiferCleanUpShot'
				}, {
					display:	'1st Lactation',
					model:		'l1CleanUpShot'
				}, {
					display:	'Lactation 2',
					model:		'l2CleanUpShot'
				}],
				timeUnitType: [{
					value:		_.get(_.find(MSF.lists.unitType,{code:"DAY"}),'unitTypeId'),
					display:	_.get(_.find(MSF.lists.unitType,{code:"DAY"}),'name')
				}, {
					value:		_.get(_.find(MSF.lists.unitType,{code:"WEEK"}),'unitTypeId'),
					display:	_.get(_.find(MSF.lists.unitType,{code:"WEEK"}),'name')
				}],
				tAIBreedToHeat: [{
					value:		true,
					display:	'Yes'
				}, {
					value:		false,
					display:	'No'
				}]
			};

			$s.loading = false;

			deregOnHerdFertilityProgramChanged = $s.$on('herdFertilityProgram:changed', ()=>{
				perfMetricSvc.startTiming('Page:FertilityProgramsBasicOnHerdFertilityProgramChanged:Render');
				perfMetricSvc.startTiming('Page:FertilityProgramsBasicOnHerdFertilityProgramChanged:Build');
				updateInputs();
				perfMetricSvc.endTiming("page",'Page:FertilityProgramsBasicOnHerdFertilityProgramChanged:Build', $s.performanceContext);
				perfMetricSvc.markPageReady('Page:FertilityProgramsBasicOnHerdFertilityProgramChanged:Render', $s.performanceContext);
			});

			$s.getInputs = function getInputs() {
				var activeHerdFertilityProgram = MSF.getActiveHerdFertilityProgram();

				return activeHerdFertilityProgram ? $s.programInputs[activeHerdFertilityProgram.herdFertilityProgramId] : {};
			};

			//#region Validations
			$s.programOverlaps = function programOverlap() {
				function overlap(a, b) {
					return	a.start	> b.start	&& a.start	< b.end	||
							a.end	> b.start	&& a.end	< b.end;
				}

				var inputs = $s.getInputs();

				if (!inputs) {
					return;
				}

				var currentlyDisplayedProgram = {
					programId:	inputs.herdFertilityProgramId	|| '',
					start:		inputs.programStartDate,
					end:		inputs.programEndDate			|| new Date('12-31-9999')
				};

				var existingPrograms = _.reduce($s.fcpCtrl.fertilityPrograms, function getStartAndEndDates(result, program) {
					if (program.herdFertilityProgramId !== currentlyDisplayedProgram.programId) {
						result.push({
							start:	new Date(program.programStartDate),
							end:	new Date(program.programEndDate)
						});
					}

					return result;
				}, []);

				if (_.isNull(currentlyDisplayedProgram.start) || !existingPrograms.length) {
					return false;
				}

				return	_.any(existingPrograms, _.ary(_.curry(overlap)(currentlyDisplayedProgram), 1)) ||
						_.any(existingPrograms, _.ary(_.curryRight(overlap)(currentlyDisplayedProgram), 1));
			};

			$s.getShortParityAbbreviation = function getShortParityAbbreviation(parityType) {	//	heifer, l1, l2
				var abbr = parityType.abbr;

				return abbr === 'heifer' ? abbr : abbr.slice(0, 1) + abbr.slice(-1);
			};

			$s.cleanUpShotClicked = function cleanUpShotClicked(parityTypeId) {
				$timeout(function timeoutToAvoidScopeApplyIfDigestIsInProgress() {
					if (parityTypeId) {
						if ($s.getInputs().l1CleanUpShot || $s.getInputs().l2CleanUpShot) {
							$s.getInputs().noCleanUpShot = false;
						} else {
							$s.getInputs().noCleanUpShot = true;
						}
					} else {
						$s.getInputs().l1CleanUpShot = false;
						$s.getInputs().l2CleanUpShot = false;
						$s.getInputs().noCleanUpShot = true;
					}
				});
			};
			//#endregion Validations

			//#region Saving
			$s.saveCommonBreedingSettings = function saveCommonBreedingSettings() {
				//	new or updated herdFertilityProgram
				var herdFertilityProgram = _.extend({}, MSF.getActiveHerdFertilityProgram(), $s.getInputs(), {
					createdBy:	MSF.cookies.user.LoginId,
					modifiedBy:	MSF.cookies.user.LoginId,
					herdId:		MSF.getActiveHerd().herdId
				});

				// if the program end date doesn't exist, make it the current program
				herdFertilityProgram.programEndDate		= herdFertilityProgram.displayedProgramEndDate ? herdFertilityProgram.displayedProgramEndDate : new Date('12-31-9999');
				herdFertilityProgram.programStartDate	= herdFertilityProgram.displayedProgramStartDate;

				if (!(
					_.isDate(herdFertilityProgram.programStartDate)	&&
					_.isDate(herdFertilityProgram.programEndDate)	&&
					herdFertilityProgram.programStartDate < herdFertilityProgram.programEndDate
				)) {
					return MSF.notify.danger('Invalid Program Configuration (check your start/end dates.)');
				}

				if ($s.programOverlaps()) {
					return MSF.notify.danger('The dates you have chosen overlap an existing program. Please select different dates.');
				}

				$s.loading = true;

				if ($s.fcpExports.isNewProgram) {
					api.createHerdFertilityProgram(herdFertilityProgram, function herdFertilityProgramCreated(err, result) {
						$s.loading = false;

						if (err) {
							var errorMessage = 'Error creating herd fertility program!';

							log.error({error: err}, errorMessage);

							return MSF.notify.danger(errorMessage);
						}

						$s.fcpExports.isNewProgram = false;
						$s.loadFertilityPrograms(function afterFertilityProgramsLoaded(programs) {
							$s.chooseFertilityProgram(_.find(programs, {herdFertilityProgramId: result.herdFertilityProgramId}));

							MSF.notify.success('Program added successfully');
						});
					});

					return false;
				}

				api.updateHerdFertilityProgram(herdFertilityProgram, function herdFertilityProgramUpdated(err) {
					$s.loading = false;

					if (err) {
						var errorMessage = 'Error updating herd fertility program!';

						log.error({error: err}, errorMessage);

						return MSF.notify.danger(errorMessage);
					}

					_.assign(MSF.getActiveHerdFertilityProgram(), $s.getInputs());

					MSF.notify.success('Changes saved successfully');
				});
			};
			//#endregion Saving

			$s.$on('$destroy', function onDestroy() {
				if (deregOnPermissionChanged) {
					deregOnPermissionChanged();
				}

				if (deregOnHerdFertilityProgramChanged) {
					deregOnHerdFertilityProgramChanged();
				}
				$s.performanceContext = null;
			});

			MSF.ready(function onReady() {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId', null));
				perfMetricSvc.startTiming('Page:FertilityProgramsBasic:Render');
				perfMetricSvc.startTiming('Page:FertilityProgramsBasic:Build');
				checkPermissions();
				updateInputs();
				addOptions();
				perfMetricSvc.endTiming("page",'Page:FertilityProgramsBasic:Build', $s.performanceContext);
				perfMetricSvc.markPageReady('Page:FertilityProgramsBasic:Render', $s.performanceContext);
			});
		}
	]);
})();
